export default __webpack_public_path__ + "static/media/failMsg.5ac436d2.svg";